<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import ConveniadoForm from '@/src/components/forms/conveniado-form.vue'
import Table from '@/src/components/tables/table-register-pagination.vue'
import agendaMedicaMixin from '@/src/mixins/agendaMedicaMixin'
import conveniadoMixin from '@/src/mixins/conveniadoMixin'
import alertMixin from '@/src/mixins/alertMixin'

export default {
  components: {
    Layout,
    HeaderPage,
    ConveniadoForm,
    Table,
  },
  mixins: [alertMixin, conveniadoMixin, agendaMedicaMixin],
  data() {
    return {
      pageTitles: {
        title: 'Conveniado',
        subtitle: 'Gerenciamento de conveniados (Médicos, Clínicas e Laboratórios) aqui.',
      },
      conveniado: {
        limite: [],
        tabelaPreco: []
      },
      conveniados: [],
      formOpen: true,
      isLoading: false,
      userType: this.$store.state.auth.currentUser.type,
      token: this.$store.state.auth.access_token,
      tabelaPreco: [],
      currentPage: 1,
      perPage: 5,
      rows: 0,
      change: {},
      statusConveniado:''
    }
  },
  watch: {
    currentPage(){
      if(this.currentPage)
        this.listandoSemTabela()
    }
  },
  mounted() {
    this.listandoSemTabela()
    
  },
  methods: {
    executeChange(){
      if(this.change.selected&&this.change.action){
        this.change.conveniado = this.conveniado._id
        this.isLoading = true;
        this.changeByDate(this.change).then(()=>{
          this.isLoading = false;
          this.successMessage('Atualizado com sucesso')
        }).error(()=>{
          this.errorMessage('Ocorreu um erro ao alterar.')
          this.isLoading = false;
        })
      }
    },
    abrirForm() {
      if (this.formOpen === true) {
        this.formOpen = false
      } else {
        this.formOpen = true
        this.conveniado = {
          limite: [],
          tabelaPreco: []
        };
        this.tabelaPreco = []
      }
    },
    changePage(page){
      this.currentPage = page
    },
    onFilter(filter){
      this.filter = filter.filter
      this.statusConveniado = filter.statusConveniado
      //this.listando()
      this.listandoSemTabela()
    },

    listandoSemTabela() {
      this.isLoading = true;
      this.conveniados = [];
      this.loadConveniadosTeste(null, this.currentPage, this.perPage, this.filter, this.statusConveniado).then((conveniados) => {
        this.conveniados = conveniados.data
        this.rows = conveniados.headers["x-total"]
        this.isLoading = false;
      })
    },

    listando() {
      this.isLoading = true;
      this.conveniados = [];
      this.loadConveniadosTeste(null, this.currentPage, this.perPage, this.filter).then((conveniados) => {
        this.conveniados = conveniados.data
        this.rows = conveniados.headers["x-total"]
        this.isLoading = false;
      })
    },
    edit(conveniado){ 
      this.isLoading = true
      this.findOneTabela(conveniado._id).then(conveniadoResponse => {
        this.conveniado = conveniadoResponse.data;
          if(!this.conveniado.tabelaPreco[0])
            this.conveniado.tabelaPreco[0] = []
          this.formOpen = false;
          this.isLoading = false
      }); 

      /*
      this.isLoading = true
      this.findOneConveniado(conveniado._id).then(conveniadoResponse => {
        this.conveniado = conveniadoResponse.data;
        if(!this.conveniado.tabelaPreco[0])
          this.conveniado.tabelaPreco[0] = []
        this.formOpen = false;
        this.isLoading = false
      })
      */
    },
    async onChangeFile(event){
      const {formData, fileName} = event
      this.isLoading = true;
      this.uploadFile(formData, fileName,this.conveniado._id).then((response) => {
        if (!this.conveniado.documentos) this.conveniado.documentos = [];

        this.conveniado.documentos.push(response.data);
        this.isLoading = false;
      });
    },
    async onEdit() {
      this.isLoading = true;
      try {
        const {tabelaPreco, ...conveniado} = this.conveniado
        await Promise.all([
          this.editConveniado(conveniado._id, conveniado),
          this.editTabelaPreco(conveniado._id, this.tabelaPreco)
        ])
        this.successMessage('Atualizado com sucesso')
      } catch (error) {
        this.errorMessage(error)
      }
      this.listando()
      this.abrirForm();
    },
    async onDelete(id) {
      this.isLoading = true;
      try {
        await this.deleteConveniado(id);
        this.modal = false
        this.successMessage("Removido com sucesso")
      } catch (error){
        this.errorMessage('Houve um error ao tentar remover')
      }

        this.listando();
    },
    async onSubmit() {
      this.isLoading = true;
      this.conveniado.tabelaPreco = []

      try {
        await this.registerConveniado(this.conveniado);
        this.successMessage('Cadastrado com sucesso');
      } catch (error) {
        this.errorMessage((error))
      }

      
      this.listando();
      this.abrirForm();
    }
  },
}
</script>

<template>
  <Layout :isLoading="isLoading">
    <div class="bloco">
      <HeaderPage
        @onClick="abrirForm"
        :formOpen="formOpen"
        :pageTitles="pageTitles"
      />
      <div>
        <div v-if="formOpen">
          <Table
            :formOpen="formOpen"
            :tablesFields="conveniadoFields"
            :tableItems="conveniados"
            :rows="rows"
            :perPage="perPage"
            :isStatusConveniado="true"
            @onEdit="edit"
            @onFilter="onFilter"
            @changePage="changePage"
            @onDelete="onDelete"
          />
        </div>
        <div v-else>
          <ConveniadoForm
            :conveniado="conveniado"
            :change="change"
            :tabelaPreco="tabelaPreco"
            :executeChange="executeChange"
            :onSubmit="onSubmit"
            :onEdit="onEdit"
            :onChangeFile="onChangeFile"
          />
        </div>
      </div>

      <div class="borda"></div>
    </div>
  </Layout>
</template>

<style src="../style.scss" lang="scss">
</style>
